import { postRequestFactory, createClient, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

export enum ResetType {
  SOFT = 'soft',
  HARD = 'hard'
}

export interface ResetCommand {
  type: ResetType;
}

const client = createClient('/rest/operator-api/charging-stations');

export const reset: SaveOperation<ResetCommand, void, string> = postRequestFactory<ResetCommand, void, string>(
  client,
  {
    pattern: '/{chargingStationId}/reset',
    permissionId: commandPermissions.RESET_CHARGING_STATION
  }
);
